<template>
  <transition name="fade">
    <div class="loading" v-show="isLoading">
      <img src="@/../images/CatSkull.gif" alt />
    </div>
  </transition>
</template>
<script>
export default {
  props: [
    'minTime'
    ],
  mounted() {
    let imageLoaded = 0;
    var imgs = document.getElementsByTagName("img");

    for (var i = 0; i < imgs.length; i++) {
      const img = new Image();
      img.src = imgs[i].src;

      img.onload = () => {
        imageLoaded++;

        if (imageLoaded === imgs.length) {
          let self = this;
          window.setTimeout(function() {
            self.isLoading = false;
          }, this.minTime);
        }
      };
    }
  },
  data() {
    return {
      isLoading: true
    };
  }
};
</script>
 <style lang="scss">
.loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 1000;
  background: radial-gradient(#4e9e95 0%, #2c9596 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 15rem;
  }
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease-out;
  &.router-link-exact-active {
    color: #42b983;
  }
}
</style>
